import React from 'react';
import { Gift } from 'lucide-react';
import { useTranslation } from '../../i18n';
import { localize } from '../../data/i18nData';
import { formatMoney } from '../../utils/format';
import { BANKS, getLoyaltyLevel, getLoyaltyLabel } from '../../data/bankData';
import { BankCard } from './BankCard';

export function ConseillerTab({ selectedBank, setSelectedBank, bank, bankRelations, relation, loyaltyLevel, reputation, vehicles, monthlyRevenues, monthlyHistory, treasury, totalDebt, totalDays }) {
  const { t } = useTranslation();
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {Object.values(BANKS).map(rawB => { const b = localize('bank', rawB); return (
          <BankCard
            key={b.id}
            bank={b}
            relation={bankRelations[b.id] || { loansRepaid: 0 }}
            isSelected={selectedBank === b.id}
            onClick={() => setSelectedBank(b.id)}
            reputation={reputation}
            vehicleCount={vehicles.length}
            monthlyRevenue={monthlyRevenues}
            monthlyHistory={monthlyHistory}
            treasury={treasury}
            totalDebt={totalDebt}
            totalDays={totalDays}
          />
        ); })}
      </div>

      {bank && (
        <div className="bg-ink-800 rounded-xl border-2 overflow-hidden" style={{ borderColor: bank.accentColor + '40' }}>
          <div className="flex items-center gap-4 p-4" style={{ background: `linear-gradient(135deg, ${bank.color}10, ${bank.color}05)` }}>
            <img src={bank.advisor.portrait} alt={bank.advisor.name} className="w-16 h-20 rounded-lg object-cover object-top border-2" style={{ borderColor: bank.color }} />
            <div className="flex-1">
              <p className="font-bold text-lg" style={{ color: bank.color }}>{bank.advisor.name}</p>
              <p className="text-xs text-slate-500">{bank.advisor.title} — {bank.name}</p>
              <p className="text-xs text-slate-400 italic mt-1">"{bank.advisor.greetings[Math.min(loyaltyLevel, bank.advisor.greetings.length - 1)]}"</p>
            </div>
          </div>
          <div className="p-4 space-y-3">
            <p className="text-xs text-slate-400">{bank.advisor.personality}</p>

            <div className="grid grid-cols-3 gap-2">
              <div className="bg-ink-700/30 rounded-lg p-2 text-center">
                <p className="text-[10px] text-slate-500">{t('loyalty')}</p>
                <p className="text-sm font-bold" style={{ color: bank.color }}>{getLoyaltyLabel(loyaltyLevel)}</p>
                <div className="h-1.5 rounded-full bg-ink-700 mt-1 overflow-hidden">
                  <div className="h-full rounded-full transition-all" style={{ width: `${(loyaltyLevel / 3) * 100}%`, backgroundColor: bank.accentColor }} />
                </div>
              </div>
              <div className="bg-ink-700/30 rounded-lg p-2 text-center">
                <p className="text-[10px] text-slate-500">{t('total_borrowed')}</p>
                <p className="text-sm font-bold text-slate-300">{formatMoney(relation.totalBorrowed)}</p>
              </div>
              <div className="bg-ink-700/30 rounded-lg p-2 text-center">
                <p className="text-[10px] text-slate-500">{t('loans_active_count')}</p>
                <p className="text-sm font-bold text-slate-300">{relation.activeLoanCount}</p>
              </div>
            </div>

            <div className="flex flex-wrap gap-1.5">
              {bank.specialties.map((s) => (
                <span key={`bank-spec-${bank.id}-${s}`} className="text-[10px] px-2 py-0.5 rounded-full border font-medium" style={{ borderColor: bank.accentColor, color: bank.color }}>
                  {s}
                </span>
              ))}
            </div>

            {loyaltyLevel >= 2 && (
              <div className="bg-warn/10 border border-warn/40 rounded-lg p-3 flex items-start gap-2">
                <Gift className="w-4 h-4 text-warn flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-xs font-semibold text-amber-800">Avantage fidélité</p>
                  <p className="text-[10px] text-warn italic">
                    "{bank.advisor.loyaltyMessage[0].replace('{years}', Math.floor((relation.loansRepaid || 0) / 2))}"
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
